import { render } from "./ActiveToggleSnippet.vue?vue&type=template&id=6ffcf5d0&scoped=true"
import script from "./ActiveToggleSnippet.vue?vue&type=script&lang=js"
export * from "./ActiveToggleSnippet.vue?vue&type=script&lang=js"

import "./ActiveToggleSnippet.vue?vue&type=style&index=0&id=6ffcf5d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffcf5d0"]])

export default __exports__